import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function ContactIntro() {
  return (
    <section aria-labelledby="contact-intro-heading" className="bg-background py-10 md:py-14">
      <div className="shell max-w-3xl">
        <Reveal>
          <Eyebrow>Let&apos;s Talk</Eyebrow>
        </Reveal>
        <h2 id="contact-intro-heading" className="display-lg mt-6">
          <MaskReveal>How Can We Help?</MaskReveal>
        </h2>
        <Reveal delay={0.08}>
          <p className="mt-6 text-base leading-relaxed text-muted-foreground">
            Send Auburn RV Resort a message using the form below and our team will review your
            question.
          </p>
        </Reveal>
        <Reveal delay={0.12}>
          <div className="mt-8 border border-border bg-secondary/40 p-6 md:p-8">
            <p className="eyebrow text-primary">Looking for an RV site?</p>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
              For daily, weekly or monthly availability, please use our Availability Request form so
              we can collect the information needed to review your stay.
            </p>
            <ResortLink variant="solid" href="/reservations/" className="mt-6 w-full sm:w-auto">
              Check Availability
            </ResortLink>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
